// Font design system is according to figma here:
// https://www.figma.com/file/6AGSvP6DJIIvy5Ayyp1a6U/Design-System?node-id=2650%3A49

/* eslint-disable sort-keys */
const fonts = {
  family: {
    default: 'Inter, sans-serif',
    mono: 'JetBrainsMono, monospace',
  },
  size: {
    d0: '48px',
    d1: '42px',
    d2: '36px',
    h1: '24px',
    h2: '20px',
    h3: '16px',
    h4: '14px',
    b1: '14px',
    b2: '12px',
    b3: '10px',
  },
  weight: {
    bold: '700',
    semiBold: '600',
    medium: '500',
    regular: '400',
    light: '300',
  },
  lineHeight: {
    default: '1.25',
  },
};

export default fonts;
